import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Col, Row, Form, FloatingLabel, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'; // Import the Select component
import GLOBALVAR from "../constants"; // Import GLOBALVAR constant
import LoadingSpinner from "../components/misc/LoadingSpinner";

function LoanProcessing() {
    const [value, setValue] = useState('');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('id');
    const [dateGranted, setDateGranted] = useState(null); // State to manage birthday
    const [showModal, setShowModal] = useState(false);
    const [modalHeader, setModalHeader] = useState(null);
    const [modalBody, setModalBody] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);
    const [errMessages, setErrMessages] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const [hasLoaded, setHasLoaded] = useState(false);

    const [formData, setFormData] = useState({
        loanProcessingType: '',
        amountGranted: '',
        dateGranted: '',
        interestRate: '',
        loanTerm: '',
        paymentType: '',
        loanInterval: '',
        serviceFee: '',
        notarialFee: '',
        docStamp: '',
        insurance: '',
        accountOfficer: '',
        loanProduct: '',
        loanLedger: '',
        loanSecurity: '',
        reference: '',
        loanType: '',
        addtl_beneficiary: '',
        addtl_contact: '',
        addtl_relationship: ''
    });
    

    const handleDateChange = (date) => {
        if(!date) return;

        setDateGranted(date);
        const formattedDate = format(date, 'MM/dd/yyyy'); 
        handleChangeInput({ target: { name: "dateGranted", value: formattedDate } });
    };

    useEffect(() => {
        let source = axios.CancelToken.source();

        const fetchOptions = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/applicationsearch?query=${value}`, {
                    cancelToken: source.token
                });
                const data = response.data;
                if (data && data.rows) {
                    const suggestions = data.rows.map(application => ({
                        label: `${application.lastName}, ${application.firstName} ${application.middleName}`,
                        value: application.id
                    }));
                    setOptions(suggestions);
                } else {
                    console.error('Invalid response structure:', data);
                    setOptions([]);
                }
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error('Error fetching suggestions:', error);
                }
            } finally {
                setLoading(false);
            }
        };
        
        if (id) {
            const fetchApplication = async () => {
                try {
                    setLoading(true);
                    const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/applications/${id}`);
                    const application = response.data;
                    setValue(`${application.lastName}, ${application.firstName} ${application.middleName}`);
                    setOptions([{ label: `${application.lastName}, ${application.firstName} ${application.middleName}`, value: application.id }]);
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        navigate('/dashboard');
                    } else {
                        console.error('Error retrieving application:', error);
                    }
                } finally {
                    setLoading(false);
                }
            };
            fetchApplication();
        } else {
            fetchOptions();
        }

        return () => {
            source.cancel();
        };
    }, [id, value, navigate]);

    useEffect(() => {
        if (id && !hasLoaded) { 
            setFormData(prevFormData => ({ ...prevFormData, applicantID: id }));
            setHasLoaded(true);
        }
    }, [id, hasLoaded]);


    const handleChange = (selectedOption) => {
        setValue(selectedOption ? selectedOption.label : '');
        setFormData({ ...formData, applicantID: selectedOption.value });
    };

    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowSpinner(true);

        console.log(formData);

        try {
            const response = await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/add`, formData);
            console.log(response.data.message); // Display the message returned from the server
            navigate('/dashboard');
        } catch (error) {
            console.error('Error submitting form:', error);
            setModalHeader('Validation Error');
            setModalBody('');

            const errorsArray = error.response.data.error.split(',\n');
            const filteredErrors = errorsArray.map(error => error.replace('notNull Violation: ', '')).filter(error => error.trim() !== '');
            setErrMessages(filteredErrors);
            handleShow();
            setShowSpinner(false);
        }
    };

    return (
        <>
            {showSpinner && (<LoadingSpinner />)}
            <NavMain slug="loan-processing" parent="1" />
            <HeaderMain slug="loan-processing" />
            <div className="main-content">
                <Modal show={showModal} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{modalHeader}</Modal.Title>
                    </Modal.Header>
                    {errMessages && (
                        <Modal.Body>
                        <ul>
                        {errMessages.map((error, index) => (
                            <li key={index}>{error.trim().replace('Validation error: ', '')}</li>
                        ))}
                        </ul>
                        </Modal.Body>
                    )}
                    {!errMessages && (
                        <Modal.Body>
                        {modalBody}
                        </Modal.Body>
                    )}
                </Modal>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col>
                            <Select
                                options={options}
                                isLoading={loading}
                                onInputChange={setValue}
                                onChange={handleChange}
                                value={options.find(option => option.label === value)}
                                placeholder="Type a name..."
                                isDisabled={id ? true : false}
                                name="applicantID"
                            />
                        </Col>
                    </Row>
                    <hr className="my-4"></hr>
                    <Row>
                        <Col>
                            <FloatingLabel controlId="floatingLoanProcessingType" label="Type of Loan">
                                <Form.Select name="loanProcessingType" onChange={handleChangeInput} onBlur={handleChangeInput}>
                                <option>Select Type of Loan</option>
                                <option value="new">New Loan</option>
                                <option value="reloan">Reloan</option>
                                <option value="restructure">Restructure</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <hr className="my-4"></hr>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingAmountGranted" label="Amount Granted">
                                <Form.Control 
                                type="number" 
                                placeholder="Amount Granted" 
                                name="amountGranted" 
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                        {dateGranted ? (
                            <DatePicker
                            className="form-control"
                            selected={dateGranted} // Set the selected date
                            onChange={(e) => {
                                handleDateChange(e);
                            }} // Handle date change
                            dateFormat="MM/dd/yyyy" // Date format
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            maxDate={new Date()} // Max date is today
                            name="dateGranted"
                            />
                        ) : (
                            <FloatingLabel controlId="floatingBirthday" label="Date Granted">
                            <DatePicker
                                className="form-control"
                                selected={dateGranted} // Set the selected date
                                onChange={(e) => {
                                    handleDateChange(e);
                                }} // Handle date change
                                dateFormat="MM/dd/yyyy" // Date format
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                name="dateGranted"
                                />
                            </FloatingLabel>
                        )}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingInterestRate" label="Interest Rate (%)">
                                <Form.Control 
                                type="number" 
                                placeholder="Interest Rate" 
                                name="interestRate" 
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingLoanTerm" label="Loan Term">
                                <Form.Control 
                                type="number" 
                                placeholder="Loan Term" 
                                name="loanTerm" 
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingPaymentType" label="Payment Type">
                                <Form.Select name="paymentType" onChange={handleChangeInput} onBlur={handleChangeInput} >
                                    <option>Select Payment Type</option>
                                    <option value="add">Add On</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingLoanInterval" label="Loan Interval">
                                <Form.Select name="loanInterval" onChange={handleChangeInput} onBlur={handleChangeInput}>
                                    <option>Select Loan Interval</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bimonthly">Bi-Monthly</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="quarterly">Quarterly</option>
                                    <option value="semiannual">Semi-Annual</option>
                                    <option value="yearly">Yearly</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <hr className="my-4"></hr>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingServiceFee" label="Service Fee">
                                <Form.Control 
                                type="number" 
                                placeholder="Service Fee" 
                                name="serviceFee" 
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingNotarialFee" label="Notarial Fee">
                                <Form.Control 
                                type="number" 
                                placeholder="Notarial Fee" 
                                name="notarialFee" 
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingDocStamp" label="Doc Stamp">
                                <Form.Control 
                                type="number" 
                                placeholder="Doc Stamp" 
                                name="docStamp" 
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingInsurance" label="Insurance">
                                <Form.Control 
                                type="number" 
                                placeholder="Insurance" 
                                name="insurance" 
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <hr className="my-4"></hr>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingAccountOfficer" label="Account Officer">
                                <Form.Control 
                                type="text" 
                                placeholder="Account Officer" 
                                name="accountOfficer" 
                                onKeyUp={handleChangeInput}
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingLoanProduct" label="Loan Product">
                                <Form.Select name="loanProduct" onChange={handleChangeInput} onBlur={handleChangeInput} >
                                    <option>Select Loan Product</option>
                                    <option value="regular">Regular Loan</option>
                                    <option value="salary">Salary Loan</option>
                                    <option value="pension">Pension Loan</option>
                                    <option value="honorarium">Honorarium Loan</option>
                                    <option value="market">Market Vendors</option>
                                    <option value="clean">Clean Loan</option>
                                    <option value="chattel">Chattel</option>
                                    <option value="rem">REM</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingLoanLedger" label="Loan Ledger">
                                <Form.Control 
                                type="text" 
                                placeholder="Loan Ledger" 
                                name="loanLedger" 
                                onKeyUp={handleChangeInput}
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingLoanSecurity" label="Loan Security">
                                <Form.Select name="loanSecurity" onChange={handleChangeInput} onBlur={handleChangeInput} >
                                    <option>Select Loan Security</option>
                                    <option value="unsecured">Unsecured</option>
                                    <option value="atm">Secured with ATM</option>
                                    <option value="pdc">Secured with PDC</option>
                                    <option value="clean">Clean Loan</option>
                                    <option value="chattel">Chattel Mortgage</option>
                                    <option value="residential">Real Estate Mortgage - Residential</option>
                                    <option value="commercial">Real Estate Mortgage - Commercial</option>
                                    <option value="others">Others</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingLoanType" label="Loan Type">
                                <Form.Select name="loanType" onChange={handleChangeInput} onBlur={handleChangeInput} >
                                    <option>Select Loan Type</option>
                                    <option value="personal">Personal Loan</option>
                                    <option value="business">Business Loan</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <hr className="my-4"></hr>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingBeneficiaryName" label="Beneficiary Name">
                                <Form.Control 
                                type="text" 
                                placeholder="Beneficiary Name" 
                                name="addtl_beneficiary" 
                                onKeyUp={handleChangeInput}
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingContactNumber" label="Contact Number">
                                <Form.Control 
                                type="text" 
                                placeholder="Contact Number" 
                                name="addtl_contact" 
                                onKeyUp={handleChangeInput}
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingRelationship" label="Relationship">
                                <Form.Control 
                                type="text" 
                                placeholder="Relationship" 
                                name="addtl_relationship" 
                                onKeyUp={handleChangeInput}
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingReference" label="Reference">
                                <Form.Control 
                                type="text" 
                                placeholder="Reference" 
                                name="reference" 
                                onKeyUp={handleChangeInput}
                                onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Button variant="primary" type="submit" className="submit-btn" id="submit-processing">Process Loan</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
}

export default LoanProcessing;
